import env from 'env'

export const getUserDetails = () => ({
  type: 'api/userProfile/GET_USER_DETAILS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/me',
      method: 'GET',
    },
  },
})
getUserDetails.toString = () => 'api/userProfile/GET_USER_DETAILS'
